import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeftIcon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
function UsFlag() {
  return <svg viewBox="0 0 24 16" className="w-5 h-3.5 rounded-sm shadow-sm shrink-0" aria-hidden="true" data-id="element-33">
      <rect width="24" height="16" fill="#B22234" data-id="element-34" />
      {/* white stripes */}
      <rect y="2" width="24" height="1.5" fill="#fff" data-id="element-35" />
      <rect y="5" width="24" height="1.5" fill="#fff" data-id="element-36" />
      <rect y="8" width="24" height="1.5" fill="#fff" data-id="element-37" />
      <rect y="11" width="24" height="1.5" fill="#fff" data-id="element-38" />
      <rect y="14" width="24" height="1.5" fill="#fff" data-id="element-39" />
      {/* blue canton */}
      <rect width="10" height="8" fill="#3C3B6E" data-id="element-40" />
      {/* simplified stars */}
      <g fill="#fff" data-id="element-41">
        <circle cx="2" cy="2" r="0.6" data-id="element-42" />
        <circle cx="5" cy="2" r="0.6" data-id="element-43" />
        <circle cx="8" cy="2" r="0.6" data-id="element-44" />
        <circle cx="3.5" cy="4" r="0.6" data-id="element-45" />
        <circle cx="6.5" cy="4" r="0.6" data-id="element-46" />
        <circle cx="2" cy="6" r="0.6" data-id="element-47" />
        <circle cx="5" cy="6" r="0.6" data-id="element-48" />
        <circle cx="8" cy="6" r="0.6" data-id="element-49" />
      </g>
    </svg>;
}
function QuebecFlag() {
  return <svg viewBox="0 0 24 16" className="w-5 h-3.5 rounded-sm shadow-sm shrink-0" aria-hidden="true" data-id="element-50">
      <rect width="24" height="16" fill="#0033A0" data-id="element-51" />
      {/* white cross */}
      <rect x="11" width="2" height="16" fill="#fff" data-id="element-52" />
      <rect y="7" width="24" height="2" fill="#fff" data-id="element-53" />
      {/* fleurs-de-lis (simplified as plus signs) */}
      <g fill="#fff" data-id="element-54">
        <path d="M5 3.5 L5.5 3.5 L5.5 2.5 L4.5 2.5 L4.5 3.5 L5 3.5 Z M4 4 L6 4 L6 4.5 L4 4.5 Z M4.5 4.5 L5.5 4.5 L5.5 5.5 L4.5 5.5 Z" data-id="element-55" />
        <path d="M19 3.5 L19.5 3.5 L19.5 2.5 L18.5 2.5 L18.5 3.5 L19 3.5 Z M18 4 L20 4 L20 4.5 L18 4.5 Z M18.5 4.5 L19.5 4.5 L19.5 5.5 L18.5 5.5 Z" data-id="element-56" />
        <path d="M5 11.5 L5.5 11.5 L5.5 10.5 L4.5 10.5 L4.5 11.5 L5 11.5 Z M4 12 L6 12 L6 12.5 L4 12.5 Z M4.5 12.5 L5.5 12.5 L5.5 13.5 L4.5 13.5 Z" data-id="element-57" />
        <path d="M19 11.5 L19.5 11.5 L19.5 10.5 L18.5 10.5 L18.5 11.5 L19 11.5 Z M18 12 L20 12 L20 12.5 L18 12.5 Z M18.5 12.5 L19.5 12.5 L19.5 13.5 L18.5 13.5 Z" data-id="element-58" />
      </g>
    </svg>;
}
export function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';
  const {
    lang,
    setLang
  } = useLanguage();
  return <header className="px-4 py-3 flex items-center justify-between bg-white z-20 relative shrink-0 border-b border-slate-100 shadow-[0_2px_6px_rgba(15,23,42,0.04)] gap-3" data-id="element-59">
      <div className="flex items-center gap-2 shrink-0" data-id="element-60">
        {!isHome && <button onClick={() => navigate(-1)} className="p-2 -ml-2 rounded-full hover:bg-slate-100 text-slate-600 transition-colors" aria-label="Back" data-id="element-61">
            <ChevronLeftIcon size={24} data-id="element-62" />
          </button>}
        <img src="https://cdn.magicpatterns.com/uploads/6Wpu37DEzvpwdeBTFKJUZL/image.png" alt="RONA Deslongchamps" className="h-10 w-auto" data-id="element-63" />
      </div>

      <div className="flex justify-end shrink-0" data-id="element-64">
        <div role="group" aria-label="Language / Langue" className="relative flex items-center bg-slate-100 rounded-full p-1 text-sm font-bold border border-slate-200 shadow-sm" data-id="element-65">
          <div className={`absolute top-1 bottom-1 w-[calc(50%-4px)] rounded-full bg-blue-600 shadow-md transition-all duration-200 ${lang === 'en' ? 'left-1' : 'left-[calc(50%+0px)]'}`} data-id="element-66" />
          <button type="button" onClick={() => setLang('en')} aria-pressed={lang === 'en'} className={`relative z-10 flex items-center gap-1.5 px-3 py-1.5 rounded-full transition-colors ${lang === 'en' ? 'text-white' : 'text-slate-600 hover:text-slate-900'}`} data-id="element-67">
            <UsFlag data-id="element-68" />
            EN
          </button>
          <button type="button" onClick={() => setLang('fr')} aria-pressed={lang === 'fr'} className={`relative z-10 flex items-center gap-1.5 px-3 py-1.5 rounded-full transition-colors ${lang === 'fr' ? 'text-white' : 'text-slate-600 hover:text-slate-900'}`} data-id="element-69">
            <QuebecFlag data-id="element-70" />
            FR
          </button>
        </div>
      </div>
    </header>;
}